<div id="{{key}}" class="px-5 py-3 doughnut-char-gadget" [ngClass]="!print ? 'download-hide' : 'd-print-inline-block'">
  <check-to-print (notify)="onPrintNotify()" [key]="key"></check-to-print>
  @if (title) {
    <h3 translate>{{title}}</h3>
  }
  @if (doughnutChartData.length) {
    <div style="display: block;">
      <canvas baseChart
        [data]="doughnutChartData"
        [labels]="doughnutChartLabels"
        [options]="options"
        [type]="doughnutChartType">
      </canvas>
      <!--        <canvas baseChart-->
      <!--                [data]="doughnutChartData"-->
      <!--                [labels]="doughnutChartLabels"-->
      <!--                [colors]="doughnutChartColors"-->
      <!--                [options]="options"-->
      <!--                [type]="doughnutChartType">-->
    <!--        </canvas>-->
  </div>
} @else {
  @if (!loader) {
    NO DATA
  } @else {
    <contentloader></contentloader>
  }
}
<div class="page-break"> </div>
</div>


